module.exports = __webpack_public_path__ + "60dd8cb98b514ba7ad479d1a7185f295.svg";